<template>
  <div class="container">
    <div class="complement-card">
      <template v-if="canChangeContacts">
        <div class="complement-card-title">{{ chatId ? '请添加车主信息' : '请完善客户信息' }}</div>
        <div v-if="!chatId" class="complement-card-desc">完善后，可直接查看系统中客户车辆信息</div>

        <div class="complement-card-form">
          <!-- 群聊进入时选择车主 -->
          <SelectExternalUser
            v-if="chatId"
            v-model="formData.external_userid"
          />
          <x-input
            v-model="formData.name"
            class="complement-card-input"
            placeholder="请填写车主姓名"
            :max="50"
          />
          <x-input
            v-model="formData.mobile_number"
            class="complement-card-input"
            placeholder="请填写手机号"
            type="tel"
            :max="11"
            is-type="china-mobile"
          />
          <x-input
            v-model="formData.plate_number"
            class="complement-card-input"
            placeholder="请填写车牌号（选填）"
            :max="8"
          />
          <x-input
            v-model="formData.vin"
            class="complement-card-input"
            :placeholder="chatId ? '请填写车架号（必填）' : '请填写车架号（建群必填）'"
            :max="17"
          />
        </div>

        <div class="complement-card-buttons">
          <x-button
            :class="[
              'complement-card-button',
              !chatId ? 'complement-card-button--default' : ''
            ]"
            @click="submit"
          >保存信息</x-button>
          <x-button v-if="!chatId" class="complement-card-button" @click="handleSaveAndCreateServiceGroup">保存并建群</x-button>
        </div>
      </template>

      <div v-if="!canChangeContacts" class="complement-card-auth-empty">
        <img src="../../stylesheets/images/aftersales-empty-1.png" alt="" slot="icon"/>
        <p class="complement-card-auth-empty__title">尚未完善客户信息</p>
        <p>请联系对应客户经理完善客户信息</p>
      </div>
    </div>

    <!-- 创建售后服务组弹窗 -->
    <CreateServiceGroupDialog ref="createServiceGroupDialog" @cancel="handleCreateServiceGroupDialogCancel" />
  </div>
</template>

<script>
import SelectExternalUser from './components/SelectExternalUser/Index.vue'
import CreateServiceGroupDialog from './components/CreateServiceGroupDialog.vue'

import { XInput, XButton } from '@lx-frontend/cvux'
import util from '@/common/util'
import mixin from './mixins/index.mixin'
import { traceEventsReport } from '@/common/report'
import authApi from '@/common/auth'

export default {
  components: {
    XInput,
    XButton,
    CreateServiceGroupDialog,
    SelectExternalUser
  },
  mixins: [mixin],
  data() {
    return {
      formData: {
        external_userid: '',
        mobile_number: '',
        name: '',
        plate_number: '',
        vin: ''
      },
      canChangeContacts: false,
      chatId: ''
    }
  },
  methods: {
    getChatId() {
      return this.$wechat.promise.then(async wx => {
        // 获取应用入口环境
        const entranceEnv = await wx.getEntranceEnv()
        // 从群聊环境进入应用
        if (entranceEnv !== 'group_chat_tools') return
        this.chatId = await wx.getCurExternalChat()
      })
    },
    validate(params, isCreateServiceGroup = false) {
      const errMsg = (msg) => {
        this.showToast(msg)
        return false
      }
      if (!params.name) return errMsg('请填写车主姓名')
      if (!util.regexpMap.regexp_mobile.test(params.mobile_number)) return errMsg('请填写正确的手机号')
      if (params.plate_number && !util.regexpMap.car_plate_number.test(params.plate_number)) return errMsg('请填写正确的车牌号')

      if (!this.chatId) {
        if (isCreateServiceGroup) {
          if (!util.regexpMap.regexp_car_vin.test(params.vin)) return errMsg('请填写正确的车架号')
        } else {
          if (params.vin && !util.regexpMap.regexp_car_vin.test(params.vin)) return errMsg('请填写正确的车架号')
        }
      } else {
        if (!util.regexpMap.regexp_car_vin.test(params.vin)) return errMsg('请填写正确的车架号')
        if (!params.external_userid) return errMsg('请选择车主')
      }
      return true
    },
    async submit() {
      const params = { ...this.formData }
      if (!this.validate(params)) return
      // 非群聊进入时，formData 中的外部联系人ID不传
      if (!this.chatId) {
        delete params.external_userid
      } else {
        params.chatid = this.chatId
      }
      if (!(await this.updateExternalUserInfo(params))) return
      //  提交成功后进行数据上报
      const traceFields = await this.getCommonTraceFields()
      traceEventsReport('2-2-1-1-0-0', [{ ...traceFields, mobile_number: this.formData.mobile_number }])
      // 根据用户车辆数量页面跳转
      this.handleToCarPage()
    },
    async handleSaveAndCreateServiceGroup() {
      const params = { ...this.formData }
      // 这里一定是私聊进入，所以 formData 中的外部联系人ID不传
      delete params.external_userid
      if (!this.validate(params, true)) return
      if (!(await this.updateExternalUserInfo(params))) return
      this.$refs.createServiceGroupDialog.open(params)
    },
    async getAuth() {
      const { authList } = await this.$store.state.promiseAuth
      this.canChangeContacts = authApi.haveEveryAuth([
        authApi.aftersales.customer_contacts_add,
        authApi.aftersales.base_car_add
      ], authList)
    },
    // 保存客户信息后，取消建群时，跳转到客户信息页
    handleCreateServiceGroupDialogCancel() {
      this.handleToCarPage()
    }
  },
  mounted() {
    // 完善客户信息页面渲染成功上报
    this.$nextTick(async () => {
      const traceFields = await this.getCommonTraceFields()
      traceEventsReport('2-2-1-0-0-0', [{ ...traceFields, page_id: this.sourcePage }])
    })
    this.getAuth()
    this.getChatId()
  }
}
</script>

<style lang="less" scoped>
@import '../../stylesheets/base/fn.less';

.container {
  padding-top: 60/@w2;
  position: relative;

  &::before {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    content: '';
    height: 320/@w2;
    z-index: -1;
    background: linear-gradient(180deg, #3975C6 0%, rgba(57, 117, 198, 0) 100%);
  }

  .complement-card {
    margin: 0 30/@w2;
    background: #fff;
    border-radius: 16/@w2;
    padding: 30/@w2;
    position: relative;
    overflow: hidden;

    .complement-card-title, .complement-card-desc {
      text-align: center;
    }

    .complement-card-title {
      font-size: 36/@w2;
      color: #333;
      line-height: 50/@w2;
      font-weight: bold;
      padding-top: 44/@w2;
    }

    .complement-card-desc {
      font-size: 26/@w2;
      line-height: 31/@w2;
      color: #999;
      padding-top: 8/@w2;
    }

    .complement-card-input {
      border-radius: 6/@w2;
      border: 1px solid #d9d9d9;
      font-size: 30/@w2;

      &::before {
        border-top: 0;
      }

      /deep/ input {
        line-height: 60/@w2;
        height: 60/@w2;
      }
    }

    &-form {
      display: flex;
      flex-direction: column;
      .gap-y(30/@w2);
      margin: 40/@w2 0;
    }

    &-buttons {
      display: flex;
      justify-content: space-between;
      .gap-x(30/@w2);

      button:disabled {
        cursor: not-allowed;
      }
    }

    .complement-card-button {
      margin-bottom: 80/@w2;
      line-height: 100/@w2;
      background: #3a5999;
      color: #fff;
      font-size: 30/@w2;
      border-radius: 5/@w2;
      border: 1px solid #3a5999;

      &::after {
        display: none;
      }

      &[disabled] {
        opacity: 0.4;
      }

      &--default {
        background: #fff;
        color: #3a5999;

        &::after {
          border-color: #3a5999;
        }
      }
    }

    .complement-card-auth-empty {
      text-align: center;
      line-height: 1.5;
      padding: 100/@w2 0 180/@w2;

      img {
        width: 180/@w2;
        height: 180/@w2;
      }

      &__title {
        font-size: 40/@w2;
        font-weight: 600;
        padding-bottom: 12/@w2;
        padding-top: 36/@w2;
      }
    }
  }
}
</style>
